// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"ban_a","InstagramEmbed__mask":"ban_b bhf_bi bhf_bo bhf_wx"};